<div class="container-fluid manage-quota-container">
    @if (loadingStatus.loadingQuotaDetails || loadingStatus.loadingUserQuotaDetails){
    <div class="d-flex justify-content-center pt-5">
        <zint-loader></zint-loader>
    </div>
    } @else {
    <div class="container">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h1>Manage {{featureName}}</h1>
            @if(showQuotaPeriodSelector) {
            <mat-form-field appearance="outline" class="quota-type-selector">
                <mat-label>Quota Period</mat-label>
                <mat-select [(value)]="selectedQuotaType" (selectionChange)="onQuotaTypeChange()">
                    <mat-option value="MONTHLY">Monthly</mat-option>
                    <mat-option value="BULK">Bulk</mat-option>
                </mat-select>
            </mat-form-field>
            }
        </div>

        @if(isParentOrgSuperUser && organisationQuotaDetails){
        <div class="zint-base-card zint-card-white mb-5">
            <div class="d-flex justify-content-between border-bottom pb-4">
                <h4 class="text-all-caps mb-0">{{organisationQuotaDetails.organisation_name}} - {{selectedQuotaType}}</h4>
                <button class="rounded-btn-base btn-p-sm"
                    [matMenuTriggerFor]="confirmEqualOrgDistro" #quotaMenuTrigger="matMenuTrigger"><i
                        class="fal fa-maximize me-1"></i> Equally Distribute Remaining Quota</button>
                <mat-menu #confirmEqualOrgDistro="matMenu" class="quota-menu" xPosition="before" yPosition="below">
                    <button class="rounded-btn-base rounded-btn-vivid-outline btn-p-xs d-block mx-auto"
                        (click)="equallyDistributeQuotas()">Confirm</button>
                </mat-menu>
            </div>
            <div class="d-flex justify-content-around pt-4">
                <div class="d-flex flex-column text-center">
                    <span><i class="fal fa-grid-2 fa-md text-primary"></i></span>
                    <h4 class="mt-2 mb-0 text-bold-600">{{organisationQuotaDetails.organisation_quota}}</h4>
                    <span>Total Allowance</span>
                </div>
                <div class="d-flex flex-column text-center">
                    <span><i class="fal fa-chart-line fa-md text-info"></i></span>
                    <h4 class="mt-2 mb-0 text-bold-600">{{organisationQuotaDetails.usage}}</h4>
                    <span>Total Used</span>
                </div>
                <div class="d-flex flex-column text-center">
                    <span><i class="fal fa-share fa-md text-warning"></i></span>
                    <h4 class="mt-2 mb-0 text-bold-600">{{orgQuotaAllocated()}}</h4>
                    <span>Allocated</span>
                </div>
                <div class="d-flex flex-column text-center">
                    <span><i class="fal fa-box-archive fa-md text-success"></i></span>
                    <h4 class="mt-2 mb-0 text-bold-600">{{orgRemainingQuota()}}</h4>
                    <span>Remaining</span>
                </div>
            </div>
        </div>

        <mat-accordion>
            @for (team of organisationQuotaDetails.teams; track team.id) {
            <mat-expansion-panel hideToggle (opened)="getTeamDetails(team.id)" #panel class="mb-4">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h5 class="mb-0 text-grey-800 fw-100">{{team.name}}</h5>
                    </mat-panel-title>
                    <span>Used: {{team.usage}} / {{team.quota}}</span>
                </mat-expansion-panel-header>

                <div class="pt-2">
                    @if (loadingStatus.loadingTeamQuotaDetails){
                    <div class="d-flex justify-content-center">
                        <zint-loader size="xSmall"></zint-loader>
                    </div>
                    }
                    @if (teamQuotaDetails && teamQuotaDetails.team_name === team.name){
                    <div class="zint-base-card d-flex flex-column">
                        <button [matMenuTriggerFor]="setTeamQuotaMenu" #teamQuotaMenuTrigger="matMenuTrigger"
                            class="rounded-btn-base rounded-btn-dark-hover align-self-end">
                            + Set Team Quota
                        </button>
                        <mat-menu #setTeamQuotaMenu="matMenu" class="quota-menu" xPosition="before" yPosition="below">
                            <div role="menu" mat-menu-item (click)="$event.stopPropagation()">
                                <h5 class="mb-0">Set Team Quota</h5>
                                <hr>
                                <span class="d-block text-grey-600">Unallocated Quota Left: <strong
                                        class="ms-4">{{orgRemainingQuota()}}</strong>
                                </span>
                                <input #teamQuotaInput type="number" class="rounded-input-base full-width my-2"
                                    [value]="team.quota" min="0"
                                    (keyup.enter)="setQuota(teamQuotaInput.valueAsNumber, undefined, team.id); teamQuotaMenuTrigger.closeMenu();">
                                <button class="rounded-btn-base rounded-btn-light btn-p-xs d-block me-0 ms-auto"
                                    (click)="setQuota(teamQuotaInput.valueAsNumber, undefined, team.id); teamQuotaMenuTrigger.closeMenu();">Set
                                    Team Quota
                                </button>
                            </div>
                        </mat-menu>
                        <span class="align-self-start">Team member allocation: {{teamQuotaDetails.currentTeamTotal}}</span>
                        <mat-progress-bar mode="determinate"
                            [value]="getProgressBarValue(teamQuotaDetails.currentTeamTotal, team.quota)"
                            class=""></mat-progress-bar>
                        <span class="align-self-end">Total Team Share: {{team.quota}}</span>

                    </div>
                    <details class="mt-4">
                        <summary><span class="text-grey-100 fw-100"><u>View Team Members Allocation</u></span>
                        </summary>

                        <div class="zint-rounded-table-container">
                            <table class="table table-layout-fixed zint-rounded-table">
                                <thead style="background: var(--zint-grey-300);">
                                    <tr>
                                        <th scope="col">Email</th>
                                        <th scope="col" class="text-end">Used / Assigned</th>
                                        <th scope="col">Update Quota</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (user of teamQuotaDetails.users; track user.id){
                                    <tr>
                                        <td class="vertical-baseline">{{user.email}}</td>
                                        <td class="vertical-baseline text-end">{{user.usage}} / {{user.quota}}</td>
                                        <td class="vertical-baseline">
                                            <input #userQuotaInput type="number"
                                                class="rounded-input-base full-width" [value]="user.quota" min="0"
                                                (keyup.enter)="setQuota(userQuotaInput.valueAsNumber, user.id, team.id)">
                                        </td>
                                        <td class="vertical-baseline">
                                            <button class="rounded-btn-base rounded-btn-light btn-p-xs small"
                                                (click)="setQuota(userQuotaInput.valueAsNumber, user.id, team.id)">Update
                                            </button>
                                        </td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </details>
                    }
                </div>
            </mat-expansion-panel>
            }
        </mat-accordion>
        }

        @if(!isParentOrgSuperUser && isSuperUser && teamQuotaDetails){
        <div class="d-flex justify-content-between mt-5 mb-2">
            <h3 class="mb-0">{{teamQuotaDetails.team_name}}</h3>
            <h4 class="mb-0">Used: {{teamQuotaDetails.team_usage}} / {{teamQuotaDetails.team_quota}}</h4>
        </div>

        <div class="zint-base-card">
            <div class="zint-base-card zint-card-white d-flex flex-column mb-3">
                <span class="align-self-start">Team member allocation: {{teamQuotaDetails.currentTeamTotal}}</span>
                <mat-progress-bar mode="determinate"
                    [value]="getProgressBarValue(teamQuotaDetails.currentTeamTotal, teamQuotaDetails.team_quota)"
                    class=""></mat-progress-bar>
                <span class="align-self-end">Total: {{teamQuotaDetails.team_quota}}</span>
            </div>
            <div class="zint-rounded-table-container">
                <table class="table table-layout-fixed zint-rounded-table">
                    <thead style="background: var(--zint-grey-300);">
                        <tr>
                            <th scope="col">Email</th>
                            <th scope="col" class="text-end">Used / Assigned</th>
                            <th scope="col">Update Quota</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (user of teamQuotaDetails.users; track user.id){
                        <tr>
                            <td class="vertical-baseline">{{user.email}}</td>
                            <td class="vertical-baseline text-end">{{user.usage}} / {{user.quota}}</td>
                            <td class="vertical-baseline">
                                <input #userQuotaInput type="number" class="rounded-input-base full-width"
                                    [value]="user.quota" min="0"
                                    (keyup.enter)="setQuota(userQuotaInput.valueAsNumber, user.id, teamQuotaDetails.id)">
                            </td>
                            <td class="vertical-baseline">
                                <button class="rounded-btn-base rounded-btn-light btn-p-xs small"
                                    (click)="setQuota(userQuotaInput.valueAsNumber, user.id, teamQuotaDetails.id)">Update
                                </button>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
        }

        @if(!isParentOrgSuperUser && !isSuperUser && userQuotaDetails){
            <progress-bar [label]="featureName" [usage]="userQuotaDetails.usage" [quota]="userQuotaDetails.assigned"></progress-bar>
            <p class="mt-3 mb-0"><strong>Remaining:</strong> {{userQuotaDetails.remaining | number}}</p>
            <p class="mt-3">Please ask your team/organisation superuser or email <a href="mailto:customersuccess@zint.io?Subject=Quotas%20Enquiry">customersuccess&#64;zint.io</a> for assistance with quotas.</p>
        }

    </div>
    }
</div>
